import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Alert,
} from "@mui/material";
import WarningIcon from "@mui/icons-material/Warning";

interface TemplateConfirmationDialogProps {
  open: boolean;
  isActivating: boolean;
  isSaving: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const TemplateConfirmationDialog = ({
  open,
  isActivating,
  isSaving,
  onConfirm,
  onCancel,
}: TemplateConfirmationDialogProps) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="confirm-dialog-title"
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle
        id="confirm-dialog-title"
        sx={{ display: "flex", alignItems: "center", gap: 1 }}
      >
        {isActivating && <WarningIcon color="warning" />}
        {isActivating ? "Activate Template?" : "Deactivate Template?"}
      </DialogTitle>
      <DialogContent>
        {isActivating && (
          <Alert severity="warning" sx={{ mb: 2 }}>
            <strong>Important:</strong> Please ensure that a validator has been
            implemented for this template in the data validator before
            activating it.
          </Alert>
        )}
        <DialogContentText>
          {isActivating
            ? "Are you sure you want to activate this template? It will be used in the data validation process."
            : "Are you sure you want to deactivate this template? It will no longer be used in the data validation process."}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onCancel}
          variant="outlined"
          sx={{
            borderColor: "grey.400",
            color: "text.secondary",
            "&:hover": {
              borderColor: "grey.600",
              bgcolor: "grey.50",
            },
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={onConfirm}
          color="primary"
          variant="contained"
          disabled={isSaving}
        >
          {isSaving ? "Updating..." : "Confirm"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default TemplateConfirmationDialog;
